// @ts-nocheck
import React, { Component } from 'react';

import styles from './product.module.scss';
import { TextStyle, TicketCardv2 } from '@ticketmaster/global-design-system';
import ProductBarcode from '@/v2/wallet/items/barcode/productBarcode.tsx';
import ProductHeader from '@/v2/wallet/items/product/header/productHeader.tsx';
import i18next from 'i18next';
import { formatMoney } from '@/v2/helpers/moneyFormatter/moneyFormatter.ts';

type Props = {
  product: ProductModel;
};

type State = any;

class Product extends Component<Props, State> {
  render() {
    const { product } = this.props;
    const status = product.voidedAt ? 'disabled' : 'primary';

    return (
      <TicketCardv2 status={status}>
        <ProductHeader product={product} />
        <div className={styles.ticketMiddleSection}>
          <ProductBarcode product={product} />
        </div>
        {!product.voidedAt && (
          <>
            <hr className={styles.divider} />
            <div className={styles.productBottomSection}>
              <TextStyle.Nevis>
                {`${formatMoney(i18next.language, product.currencyCode, product.price)}`}
              </TextStyle.Nevis>
            </div>
          </>
        )}
      </TicketCardv2>
    );
  }
}

export default Product;
